var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { attrs: { column: "" } },
    [
      _c(
        "v-parallax",
        {
          attrs: {
            src: "https://gm.goz.fun/wp-content/uploads/2023/03/checkout-cover.png",
            height: "400",
            role: "img",
            "aria-label": "Checkout background artwork",
          },
        },
        [
          _c(
            "v-layout",
            { attrs: { column: "", "align-center": "", "justify-center": "" } },
            [
              _c("h1", { staticClass: "white--text" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("components.checkout.title")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "white--text" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("components.checkout.subtitle")) +
                    "\n      "
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.hasConfigLoaded,
              expression: "!hasConfigLoaded",
            },
          ],
          attrs: { flat: "", height: "250px" },
        },
        [
          _c(
            "v-container",
            [
              _c(
                "v-layout",
                {
                  attrs: {
                    column: "",
                    "align-center": "",
                    "justify-center": "",
                  },
                },
                [
                  _c("v-progress-circular", {
                    attrs: {
                      size: 50,
                      color: "accent",
                      indeterminate: "",
                      role: "status",
                      "aria-label": "Loading payment options",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasConfigLoaded,
              expression: "hasConfigLoaded",
            },
          ],
          attrs: { flat: "" },
        },
        [
          _c(
            "v-toolbar",
            { attrs: { color: "primary" } },
            [
              _c("v-toolbar-title", { staticClass: "white--text" }, [
                _c("h3", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("components.checkout.selectPoints")) +
                      "\n        "
                  ),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("router-view", {
            attrs: {
              role: "region",
              "aria-live": "polite",
              "aria-label": "Checkout content section",
            },
          }),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "v-container",
                { attrs: { fluid: "" } },
                [
                  _c(
                    "v-flex",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isLoading,
                          expression: "!isLoading",
                        },
                      ],
                      attrs: {
                        column: "",
                        "align-center": "",
                        "justify-center": "",
                      },
                    },
                    [
                      _c(
                        "v-radio-group",
                        {
                          attrs: {
                            column: "",
                            "aria-label": "Available point packages",
                            role: "combobox",
                          },
                          model: {
                            value: _vm.currentCost,
                            callback: function ($$v) {
                              _vm.currentCost = $$v
                            },
                            expression: "currentCost",
                          },
                        },
                        _vm._l(
                          _vm.paymentPrices,
                          function (paymentPoints, paymentPrice) {
                            return _c("v-radio", {
                              key: paymentPoints,
                              attrs: {
                                value: paymentPrice,
                                label: _vm.setProductName(
                                  paymentPrice,
                                  paymentPoints
                                ),
                                color: "accent",
                                name: "points-price",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.onPriceChange(
                                    paymentPrice,
                                    paymentPoints
                                  )
                                },
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card",
            [
              !_vm.hasReachedPayPalQualifiedAmount
                ? _c(
                    "v-alert",
                    {
                      attrs: {
                        color: "info",
                        icon: "info",
                        role: "alert",
                        "aria-live": "polite",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              "components.checkout.restrictions.unableToUsePayPalMinAmount"
                            )
                          ) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-alert",
                {
                  attrs: {
                    color: "info",
                    icon: "info",
                    role: "alert",
                    "aria-live": "polite",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("components.checkout.revolut")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.isStripeEnabled
                ? _c("stripe-checkout", {
                    ref: "checkoutStripeRef",
                    attrs: {
                      locale: "en",
                      mode: _vm.stripeMode,
                      pk: _vm.getStripePk,
                      "line-items": _vm.stripeLineItems,
                      "customer-email": _vm.email,
                      "client-reference-id": String(_vm.order.id),
                      "success-url": _vm.stripeSuccessUrl,
                      "cancel-url": _vm.stripeCancelUrl,
                      "session-id": _vm.session.id,
                    },
                    on: {
                      loading: function (v) {
                        return (_vm.isStripeLoading = v)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-toolbar",
                { attrs: { color: "primary" } },
                [
                  _c("v-toolbar-title", { staticClass: "white--text" }, [
                    _c("h3", [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("components.checkout.payments")) +
                          "\n          "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  !_vm.hasStripelRestriction && _vm.isStripeEnabled
                    ? _c(
                        "v-btn",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isLoading,
                              expression: "!isLoading",
                            },
                          ],
                          attrs: {
                            color: "accent",
                            "aria-label": "Pay with Stripe",
                            role: "button",
                          },
                          on: { click: _vm.checkoutStripeOneTimePayment },
                        },
                        [
                          _c("v-icon", { attrs: { large: "" } }, [
                            _vm._v("\n            fab fa-stripe\n          "),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isPayPalEnabled &&
                  !_vm.hasPayPalRestriction &&
                  _vm.hasReachedPayPalQualifiedAmount
                    ? _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isLoading,
                            expression: "!isLoading",
                          },
                        ],
                        attrs: { id: "paypal-button-container" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-spacer"),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-toolbar",
                { attrs: { color: "primary" } },
                [
                  _c("v-toolbar-title", { staticClass: "white--text" }, [
                    _c("h3", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("components.checkout.supportus.title")
                          ) +
                          "\n          "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        "aria-label": "Donate using PayPal",
                        color: "accent",
                        role: "button",
                      },
                      on: { click: _vm.donateForFree },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "components.checkout.supportus.buttons.paypal"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(
                _vm.filteredErrors,
                function (errorsGroup, errorsGroupIndex) {
                  return _c(
                    "div",
                    { key: errorsGroupIndex, attrs: { "aria-live": "polite" } },
                    _vm._l(errorsGroup, function (error) {
                      return _c(
                        "v-alert",
                        {
                          key: error.id,
                          attrs: {
                            type: error.type,
                            icon: error.icon,
                            role: "alert",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(error.msg) + "\n        "
                          ),
                        ]
                      )
                    }),
                    1
                  )
                }
              ),
              _vm._v(" "),
              _c("v-progress-linear", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isLoading,
                    expression: "isLoading",
                  },
                ],
                attrs: {
                  color: "accent",
                  indeterminate: "",
                  role: "status",
                  "aria-label": "Processing payment",
                },
              }),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c("v-card-title", { staticClass: "pb-0" }, [
                _c("h3", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("components.checkout.bundleTitle")) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "v-card-title",
                { staticClass: "display-5 pt-1 pb-0 font-weight-thin" },
                [
                  _c("span", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("components.checkout.bundleInfo", {
                            total: _vm.total,
                            points: _vm.points,
                            currency: _vm.currencySymbol,
                          })
                        ) +
                        "\n        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-list",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "display-5 pt-1 pb-0 font-weight-thin" },
                    [
                      _c("h3", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("components.checkout.evaluating")) +
                            "\n          "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item",
                    [
                      _c(
                        "v-list-item-content",
                        { staticClass: "font-weight-thin" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("components.checkout.gold")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        { staticClass: "align-center" },
                        [
                          _c(
                            "v-chip",
                            { staticStyle: { "min-width": "120px" } },
                            [
                              _c("v-avatar", [
                                _c("img", {
                                  attrs: {
                                    src: "https://gm.goz.fun/wp-content/uploads/2023/03/gold-icon.png",
                                    alt: "Gold currency icon",
                                  },
                                }),
                              ]),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.gold) +
                                  "\n            "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item",
                    [
                      _c(
                        "v-list-item-content",
                        { staticClass: "font-weight-thin" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("components.checkout.silver")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        { staticClass: "align-center" },
                        [
                          _c(
                            "v-chip",
                            { staticStyle: { "min-width": "120px" } },
                            [
                              _c("v-avatar", [
                                _c("img", {
                                  attrs: {
                                    src: "https://gm.goz.fun/wp-content/uploads/2023/03/silver-icon.png",
                                    alt: "Silver currency icon",
                                  },
                                }),
                              ]),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.silver) +
                                  "\n            "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "700",
            persistent: _vm.hasPayPalRestriction && _vm.hasStripelRestriction,
            transition: "dialog-bottom-transition",
            fullscreen: _vm.$vuetify.breakpoint.mdAndDown,
            width: _vm.$vuetify.breakpoint.mdAndDown ? "auto" : "700",
            role: "dialog",
            "aria-modal": "true",
            "aria-label": _vm.$t(
              "components.checkout.restrictions.dialog.title"
            ),
            "aria-labelledby": "paymentRestrictionDialogTitle",
          },
          model: {
            value: _vm.isRestrictedPaymentsDialogVisible,
            callback: function ($$v) {
              _vm.isRestrictedPaymentsDialogVisible = $$v
            },
            expression: "isRestrictedPaymentsDialogVisible",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { color: "secondary" } },
                [
                  _c(
                    "v-toolbar-title",
                    { attrs: { id: "paymentRestrictionDialogTitle" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "components.checkout.restrictions.dialog.title"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "components.checkout.restrictions.dialog.description"
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    { attrs: { "three-line": "", subheader: "" } },
                    [
                      _c("v-subheader", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "components.checkout.restrictions.dialog.subtitle"
                              )
                            ) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.hasPayPalRestriction
                        ? _c(
                            "v-list-item",
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "components.checkout.buttons.paypal"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-list-item-subtitle", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "components.checkout.restrictions.dialog.paypal"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasStripelRestriction
                        ? _c(
                            "v-list-item",
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "components.checkout.buttons.stripe"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-list-item-subtitle", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "components.checkout.restrictions.dialog.stripe"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c("v-subheader", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "components.checkout.restrictions.dialog.contact"
                          )
                        ) +
                        "\n        "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        "aria-label": "Contact via Facebook Page",
                        flat: "",
                        color: "accent",
                        role: "link",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toLink(_vm.communities.fbPage)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "components.checkout.restrictions.dialog.buttons.fbPage"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        "aria-label": "Join Discord",
                        flat: "",
                        color: "accent",
                        role: "link",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toLink(_vm.communities.discord)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "components.checkout.restrictions.dialog.buttons.discord"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _vm.hasPayPalRestriction && _vm.hasStripelRestriction
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            "aria-label": "Go to Profile",
                            role: "link",
                            color: "accent",
                            flat: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.toProfile()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "components.checkout.restrictions.dialog.buttons.profile"
                                )
                              ) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !(_vm.hasPayPalRestriction && _vm.hasStripelRestriction)
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "accent",
                            "aria-label": "Continue",
                            role: "button",
                            flat: "",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.setRestrictedPaymentsDialogVisiblity(
                                false
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "components.checkout.restrictions.dialog.buttons.continue"
                                )
                              ) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }